export default class Base {
  constructor(name, Vue, store) {
    this.name = name
    this.vm = Vue
    this.store = store
  }

  match(middlewareNames) {
    return ~middlewareNames.indexOf(this.name)
  }

  before(to, from, next) {
    next()
  }

  exec(to, from, next) {
    if (this.match(_.has(to.meta, "middleware.before") ? to.meta.middleware.before : [])) {
      console.log("before match")

      this.before(to, from, next)
    } else {
      console.log("before none")
      next()
    }
  }
}
